import EnhancedTextField from "../../../EnhancedTextField";
import moment from "moment";
import EnhancedSelect from "../../../EnhancedSelect";
import { StyledFilterControl, StyledFilterSelector } from "../../catalog_filters";
import React from "react";
import { Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';

type FilterPrimitive = string | number | boolean | null;
type FilterOption = { label: string; value?: unknown };
type FilterValue = FilterPrimitive | FilterPrimitive[] | [string, string] | Record<string, unknown>;

interface SelectValueOption {
  value: string | number | boolean;
  label: string;
}

interface FilterFieldProps {
  type?: string;
  value: FilterValue;
  onValueChange: (event: { value: FilterValue } | React.ChangeEvent<HTMLInputElement> | { value: '' } | { value: [] }) => void;
  operator?: string;
  options?: FilterOption[] | null;
  loadingOptions?: boolean;
}

function FilterField(props: FilterFieldProps) {
  const theme = useTheme();
  const { type, value, onValueChange, operator } = props;
  const { options, loadingOptions } = props;

  const [value2, setValue2] = React.useState<string>(
    Array.isArray(value) && value.length > 1 && typeof value[1] === 'string' ? value[1] : ''
  );

  if (loadingOptions || options) {
    const currentValue: SelectValueOption[] = value === ""
      ? []
      : Array.isArray(value)
        ? value.map((v) => typeof v === 'object' && v !== null
          ? (v as SelectValueOption)
          : { value: v as string | number | boolean, label: String(v) })
        : [{ value: value as string | number | boolean, label: String(value) }];

    return (
      <EnhancedSelect
        placeholder={"Value"}
        value={currentValue}
        options={options == null ? [] : options.map((option) => ({ value: option.label, label: option.label }))}
        onChange={(e: SelectValueOption[] | SelectValueOption | null) => {
          if (Array.isArray(e)) {
            const values = e.map((item) => item.value);
            onValueChange({ value: values });
          } else if (e) {
            onValueChange({ value: e.value });
          } else {
            onValueChange({ value: [] });
          }
        }}
        isMulti={true}
        isClearable
        containerStyle={{ flex: 0.6, minWidth: "200px" }}
        selectorStyle={StyledFilterSelector}
        controlStyle={StyledFilterControl}
        placeholderStyle={{ color: theme.palette.textPrimary.main }}
        dropdownIndicatorStyle={{ color: theme.palette.textPrimary.main }} />
    );
  } if (type === "bool") {
    return (
      <EnhancedSelect
        placeholder={"Value"}
        value={(value === "") ? "" : { value: value as boolean, label: `${value}` }}
        options={[
          { value: true, label: "true" },
          { value: false, label: "false" }
        ]}
        onChange={(e: SelectValueOption | null) => {
          onValueChange(e || { value: "" });
        }}
        isClearable
        containerStyle={{ flex: 0.6, minWidth: "200px" }}
        selectorStyle={StyledFilterSelector}
        controlStyle={StyledFilterControl}
        placeholderStyle={{ color: theme.palette.textPrimary.main }}
        dropdownIndicatorStyle={{ color: theme.palette.textPrimary.main }} />

    );
  } if (operator === 'datebt' && (type === "date" || type === "localdate")) {
    return (
      <div style={{ display: 'flex', gap: '8px', flex: 0.6, minWidth: '200px' }}>
        <EnhancedTextField
          type="date"
          placeholder="Start"
          InputProps={{
            inputProps: {
              max: Array.isArray(value) && value[1] && (typeof value[1] === 'string' || typeof value[1] === 'number')
                ? moment(value[1]).format("YYYY-MM-DD")
                : value2
                  ? moment(value2).format("YYYY-MM-DD")
                  : ""
            }
          }}
          value={
            Array.isArray(value) && value[0] && (typeof value[0] === 'string' || typeof value[0] === 'number')
              ? moment(value[0]).format("YYYY-MM-DD")
              : value && !Array.isArray(value)
                ? moment(value as string).format("YYYY-MM-DD")
                : ""
          }
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const startDate = moment(e.target.value, "YYYY-MM-DD").toISOString(false);
            const endDate = value2 || (Array.isArray(value) && typeof value[1] === 'string' ? value[1] : '') || '';
            onValueChange({ value: [startDate, endDate] });
          }}
          style={{ flex: 1 }}
        />
        <Typography variant="body2" style={{ alignSelf: 'center', margin: '0 4px' }}>-</Typography>
        <EnhancedTextField
          type="date"
          placeholder="End"
          InputProps={{
            inputProps: {
              min: Array.isArray(value) && value[0] && (typeof value[0] === 'string' || typeof value[0] === 'number')
                ? moment(value[0]).format("YYYY-MM-DD")
                : ""
            }
          }}
          value={
            Array.isArray(value) && value[1] && (typeof value[1] === 'string' || typeof value[1] === 'number')
              ? moment(value[1]).format("YYYY-MM-DD")
              : value2
                ? moment(value2).format("YYYY-MM-DD")
                : ""
          }
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const endDate = moment(e.target.value, "YYYY-MM-DD").toISOString(false);
            const startDate = Array.isArray(value) && value[0] ? String(value[0]) : '';
            setValue2(endDate);
            onValueChange({ value: [startDate, endDate] });
          }}
          style={{ flex: 1 }}
        />
      </div>
    );
  }
  return (
    <div style={{ flex: 0.6, minWidth: "200px" }}>
      <EnhancedTextField
        type={
          (type === "date" || type === "localdate")
            ? "date"
            : type === "number" ? "number" : "text"
        }
        value={
          type === "date" || type === "localdate"
            ? value === ""
              ? ""
              : moment(value as string).format("YYYY-MM-DD")
            : (value as string | number | readonly string[] | undefined)
        }
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          if (type === "date" || type === "localdate") {
            onValueChange({ value: moment(e.target.value, "YYYY-MM-DD").toISOString(false) });
          } else if (type === "number") {
            onValueChange({ value: Number(e.target.value) });
          } else {
            onValueChange(e.target);
          }
        }} />
    </div>
  );
}

export default FilterField;
